import api, { apiSetup } from '../api';

apiSetup();

export class EstadosFinanciamientoService {
  BASE_URL = '/estados-financiamiento';

  get() {
    return api.get(this.BASE_URL);
  }
}
